import {useI18n} from 'vue-i18n'
import {store, IS_PRODUCT_LANGS} from '@/components/store.js'

// Mutace, ve kterých se názvy produktů berou z katalogu IS. Ostatní mutace mají
// v košíku názvy z locales a do Swiss posílají výchozí (český) název z IS.
const CATALOG_NAME_LANGS = ['sk'];

export function useProductName() {
    const {t, te} = useI18n({useScope: 'global'})

    const isProductLang = () => IS_PRODUCT_LANGS[store.form.language];

    // Překlad z katalogu podle jazyka mutace, nebo null.
    function fromCatalog(product) {
        if (!CATALOG_NAME_LANGS.includes(isProductLang())) return null;
        const translation = (product.nameTranslations || [])
            .find(tr => tr.languageId === isProductLang());
        return translation && translation.translation ? translation.translation : null;
    }

    // Kurátorovaný název z locales, nebo null.
    function fromLocales(product) {
        const key = 'productNameFallback.' + product.code;
        return te(key) ? t(key) : null;
    }

    // Katalog občas nese název s mezerou na konci; šablony za něj lepí dvojtečku.
    const normalize = (name) => (name || '').trim();

    // Název pro zákazníka (košík).
    function productName(product) {
        if (!product) return '';
        return normalize(fromCatalog(product) || fromLocales(product) || product.name);
    }

    function serviceName(product) {
        if (!product) return '';
        return normalize(fromLocales(product) || fromCatalog(product) || product.name);
    }

    // Název položky objednávky do Swiss.
    function orderItemName(product) {
        if (!product) return '';
        return normalize(fromCatalog(product) || product.name);
    }

    return {productName, serviceName, orderItemName}
}
